import { OptionTile } from "@manifesthhqinc/ui-library";
import { TitleLarge } from "../../../components/font";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import ScrollableContainer from "../../../layout/scrollable-container";
import { OptionTileContainer } from "./styles";
import { InvestmentConfidence, UseHenryQuestionniareProps } from "../useHenryQuestionnaire";
import HeadingContainer from "../../../layout/heading-container";

const HenryQuestionnaireFour = (props: UseHenryQuestionniareProps) => {
  const { updateHenryQuestionnaire } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="henry-questionnaire-form-1">
        <Container>
          <HeadingContainer paneVariant="optionForm" withProgressBar>
            <TitleLarge>How comfortable do you feel making investment decisions on your own?</TitleLarge>
          </HeadingContainer>
          <OptionTileContainer>
            <OptionTile
              name="yes"
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHenryQuestionnaire({ investmentConfidence: InvestmentConfidence.COMFORTABLE })}
            >
              Comfortable — I’ve done this before
            </OptionTile>
            <OptionTile
              name="no"
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHenryQuestionnaire({ investmentConfidence: InvestmentConfidence.NOT_CONFIDENT })}
            >
              Not very — I’d rather have guidance
            </OptionTile>
            <OptionTile
              name="no"
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHenryQuestionnaire({ investmentConfidence: InvestmentConfidence.MODERATE })}
            >
              Somewhere in the middle
            </OptionTile>
          </OptionTileContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};
export default HenryQuestionnaireFour;
